<template>
  <div>
    <ReLinkingItemList
        :items="items"
        heading="calculator.reLinking.recentConversions"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ReLinkingItemList from '@/components/Calculator/ReLinking/ReLinkingItemList.vue';
import UrlGenerator from '@/services/calculatorUrlGenerator';

export default {
  name: 'RecentConversions',
  components: { ReLinkingItemList },
  computed: {
    ...mapState('calculator', ['recentConversions']),
    items () {
      return this.recentConversions.map(({ cryptoCode, fiatCode, cryptoAmount }) => {
        return {
          link: UrlGenerator.cryptoToFiatWithAmount(cryptoCode, fiatCode, cryptoAmount, this.$i18n.locale),
          hint: {
            path: 'calculator.pageTitle.cryptoToFiatWithAmount',
            args: {
              cryptoAmount,
              cryptoCode,
              fiatCode,
            },
          },
          title: {
            path: 'calculator.pageTitle.cryptoToFiatWithAmount',
            args: {
              cryptoAmount: this.formatAmount(cryptoAmount),
              cryptoCode,
              fiatCode,
            },
          },
        };
      });
    },
  },
  methods: {
    formatAmount (cryptoAmount) {
      const maxLength = 12;
      if (cryptoAmount.length <= maxLength) {
        return cryptoAmount;
      }

      const limitedAmount = cryptoAmount.substr(0, 11);

      if (limitedAmount.substr(-1, 1) === '.') {
        return `${limitedAmount}..`;
      }

      return `${limitedAmount}...`;
    },
  },
};
</script>
